import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { of as observableOf } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';

import { AccountTypeEnum, UserState } from '@amfam/shared/user';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import { AuthService } from '../../../core';
import * as fromRoot from '../../../core/store';

@Injectable()
export class PolicyCustomerGuard {
  constructor(
    private store: Store<fromRoot.RootState>,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserType();
  }

  canLoad(route: Route) {
    return this.checkUserType();
  }

  private checkUserType() {
    if (this.authService.isLoggedIn()) {
      return this.userValidation();
    } else {
      return this.authService.refresh().pipe(mergeMap(() => this.userValidation()));
    }
  }

  private userValidation() {
    return this.authService.currentUser$.pipe(
      take(1),
      map((user: UserState) => {
        if (user.typeOfAccountCode === AccountTypeEnum.Customer) {
          return true;
        }
        return this.setRedirect(user.typeOfAccountCode);
      }),
      catchError(error => {
        return observableOf(this.setRedirect(AccountTypeEnum.Customer));
      })
    );
  }

  private setRedirect(userTypeCode: string): boolean {
    switch (userTypeCode) {
      case AccountTypeEnum.CFR:
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/business/policies']
          })
        );
        break;
      default:
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/overview']
          })
        );
    }

    return false;
  }
}
